export * from "./schemas/common";
export * from "./schemas/tenant";
export * from "./schemas/user";
export * from "./schemas/role";
export * from "./schemas/feature";
export * from "./schemas/permissions";
export * from "./schemas/me";
export * from "./schemas/facility";
export * from "./schemas/asset";
export * from "./schemas/device";
export * from "./schemas/profile";
export * from "./schemas/state";
export * from "./schemas/map";
export * from "./schemas/alert";
export * from "./schemas/work-item";
export * from "./schemas/command";
export * from "./schemas/integration";
export * from "./schemas/identity";
export * from "./schemas/event";
export * from "./schemas/inventory";
export * from "./schemas/password";
export * from "./schemas/field-scope";

import { z } from "zod";

/**
 * Lightweight schema for the public `/healthz` route. Defined here rather
 * than in a dedicated file because there is exactly one route consuming it.
 */
export const HealthCheckSchema = z.object({
  ok: z.literal(true),
  service: z.string(),
  env: z.string(),
  ts: z.string().datetime(),
  requestId: z.string(),
  region: z.string(),
});
export type HealthCheck = z.infer<typeof HealthCheckSchema>;
